import { X } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { startDrag } from "@/components/UscLayout";

const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

const moveSnap = (e, o, onMove) => {
  const el = e.currentTarget;
  const layer = el.closest("[data-overlay-layer]").getBoundingClientRect();
  const k = layer.width / 1280, h = layer.height / k;
  startDrag(e, { dx: 0, dy: 0 }, ({ dx, dy }) => onMove({ ...o, x: clamp(o.x + dx / 1280, -0.2, 1), y: clamp(o.y + dy / h, -0.2, 1) }), el);
};

const drag = (e, o, onMove, resize) => {
  e.preventDefault();
  e.stopPropagation();
  const layer = e.currentTarget.closest("[data-overlay-layer]");
  const r = layer.getBoundingClientRect();
  const sx = e.clientX, sy = e.clientY;
  const move = (ev) => {
    const dx = (ev.clientX - sx) / r.width, dy = (ev.clientY - sy) / r.height;
    onMove(resize ? { ...o, w: clamp(o.w + dx, 0.03, 1) } : { ...o, x: clamp(o.x + dx, -0.2, 1), y: clamp(o.y + dy, -0.2, 1) });
  };
  const up = () => { window.removeEventListener("pointermove", move); window.removeEventListener("pointerup", up); };
  window.addEventListener("pointermove", move);
  window.addEventListener("pointerup", up);
};

const Overlay = ({ o, editable, onChange, onRemove }) => (
  <div data-snap="1" className={`absolute ${editable ? "group/o cursor-move touch-none outline-dashed outline-1 outline-transparent hover:outline-white/70" : ""}`}
    style={{ left: `${o.x * 100}%`, top: `${o.y * 100}%`, width: `${o.w * 100}%` }}
    onPointerDown={editable ? (e) => moveSnap(e, o, onChange) : undefined} data-testid={`poster-overlay-${o.id}`}>
    <img src={mediaUrl(o.url)} alt="" crossOrigin="anonymous" draggable={false} className="block h-auto w-full select-none" />
    {editable && <>
      <button onPointerDown={(e) => e.stopPropagation()} onClick={onRemove} title="Retirer l'image" data-testid={`poster-overlay-remove-${o.id}`}
        className="absolute -right-3 -top-3 hidden h-6 w-6 items-center justify-center rounded-full bg-red-500 text-white group-hover/o:flex"><X className="h-3.5 w-3.5" /></button>
      <span onPointerDown={(e) => drag(e, o, onChange, true)} title="Redimensionner" data-testid={`poster-overlay-resize-${o.id}`}
        className="absolute -bottom-2 -right-2 hidden h-5 w-5 cursor-nwse-resize rounded-sm border-2 border-white bg-orange-500 group-hover/o:block" />
    </>}
  </div>
);

export const PosterOverlays = ({ data, editable, onChange }) => {
  const list = data.overlays || [];
  if (!list.length) return null;
  const set = (overlays) => onChange({ ...data, overlays });
  return (
    <div data-overlay-layer className="pointer-events-none absolute inset-0 z-20" data-testid="poster-overlays">
      {list.map((o) => (
        <div key={o.id} className="pointer-events-auto contents">
          <Overlay o={o} editable={editable} onChange={(n) => set(list.map((x) => (x.id === o.id ? n : x)))} onRemove={() => set(list.filter((x) => x.id !== o.id))} />
        </div>
      ))}
    </div>
  );
};
